export const NAME = 'typeTasks';

export const FILTER_TYPE = {
	custom: 'customFilterPageIds',
	quick: 'quickFilterPageIds',
};
